import { render } from "./IconClone.vue?vue&type=template&id=a70d4d30"
import script from "./IconClone.vue?vue&type=script&lang=js"
export * from "./IconClone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__